<script>
  import { onMount } from 'svelte';
  import { fadeIn } from '@pernod-ricard-global-cms/jsanimations';

  onMount(() => {
    const projectsContainer = document.querySelector('.work-section');
    setTimeout(() => {
      fadeIn(projectsContainer, 1500);
    }, 1500);
  });
</script>

<section class="portfolio work-section">
  <h3 id="work-section__title" class="work-section__title">Fun side projects</h3>
  <hr class="fat-line" />
  <div class="work-section__projects">
    <div class="nasa-space-viewer work-section__project">
      <h4 class="work-section__project__title">NASA Image Of The Day</h4>
      <a class="work-section__link" href="https://nasaimageviewer.ciarankamp.com" target="_blank">https://nasaimageviewer.ciarankamp.com</a>
      <a class="project__image-link" href="https://nasaimageviewer.ciarankamp.com" target="_blank">
        <img src="images/space.webp" alt="nasa space" class="project__image" />
      </a>
      <details class="work-section__project__details">
        <summary>
          <h6>Lightweight web app for displaying the NASA astronomy photo of the day</h6>
        </summary>
        <p>Hand rolled with Vanilla JS and HTML plus a sprinkling of SCSS and Webpack</p>
      </details>
    </div>

    <!-- <div id="coffee-time-area" class="work-section__project">
			<h4 class="center">Coffee Time!</h4>
			<a
				class="work-section__link"
				href="https://coffeetime.ciarankamp.com"
				target="_blank">https://coffeetime.ciarankamp.com</a
			>
			<a
				class="project__image-link"
				href="https://coffeetime.ciarankamp.com"
				target="_blank"
			>
				<img
					src="../images/cap.webp"
					alt="coffee time"
					class="project__image"
				/>
			</a>
			<details class="work-section__project__details">
				<summary>
					<h6>
						Entertaining countdown timer for brewing the perfect
						cafetiere! Can also be installed as a PWA.
					</h6>
				</summary>
				<p>
					Made with Gatsby JS with a wordpress rest api for some
					editable content.
				</p>
			</details>
		</div> -->
  </div>
</section>

<style lang="scss">
  .work-section {
    text-align: center;
    opacity: 0;
  }
  .work-section {
    &__projects {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 40px;
    }
  }
  .work-section {
    &__project {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      &__details {
        padding: 0 40px;
      }
    }
  }
</style>
